import { buildProps, definePropType } from '@ll-plus/utils'

import { iconTypes } from '@ll-plus/components'

import type { IconBaseProps, TooltipProps } from '@ll-plus/components'
import type { ExtractPropTypes } from 'vue'
import type OperateIcon from './operate-icon.vue'

export const operateIconProps = buildProps({
  /**
   * @description 是否显示dropdown
   */
  showDropdown: {
    type: Boolean,
    default: false,
  },
  /**
   * @description  icon列表
   */
  list: {
    type: definePropType<IconBaseProps[]>(Array),
  },
  /**
   * @description 是否禁用
   */
  disabled: {
    type: Boolean,
    default: false,
  },
  /**
   * @description 显示多少个icon,其余在弹窗中显示
   */
  showIconLimit: {
    type: Number,
    default: 3,
  },
  /**
   * @description 点击按钮传递的数据
   */
  data: {
    type: definePropType<any>(undefined),
  },
  /**
   * @description 默认icon（edit和delete）的样式
   */
  iconType: {
    type: String,
    values: iconTypes,
  },
  /**
   * @description 触发下拉的行为
   */
  trigger: {
    type: definePropType<string[]>(Object),
    default: () => ['click'],
  },
  /**
   * @description 弹窗class类名
   */
  overlayClassName: {
    type: String,
  },
  /**
   * @description 弹窗class类名
   */
  showDropdownItemIcon: {
    type: Boolean,
    default: false,
  },
  dropdownOpen: {
    type: Boolean,
    default: false,
  },
  /**
   * @description 设置下拉菜单父级位置
   */
  getPopupContainer: {
    type: Function,
    default: () => document.body,
  },
  tooltipProps: {
    type: definePropType<TooltipProps>(Object),
    default: () => ({}),
  },
} as const)

export const operateIconEmits = {
  edit: (v: Event, data: any) => v || data, // 点击编辑
  delete: (v: Event, data: any) => v || data, // 点击删除
  onDropdownOpenChange: (open: boolean) => open || true, // 下拉菜单的open
}

// props
export type OperateIconProps = ExtractPropTypes<typeof operateIconProps>

// emits
export type OperateIconEmits = typeof operateIconEmits

// instance
export type OperateIconInstance = InstanceType<typeof OperateIcon>
